<template>
  <div class="contact-import-page">
    <ContactImportUpload
      :override-import-type="'contact'"
      :pageCopy="page_copy"
      :fieldDefinitions="field_definitions"
      :previewConfig="preview_config"
    />
  </div>
</template>

<script>
import ContactImportUpload from '@/components/contacts/contact-import-component.vue';

export default {
  name: 'ContactImportPage',
  components: { ContactImportUpload },
  computed: {
    page_copy() {
      return {
        pageTitle: 'Import Contacts',
        instructionsText: 'Use this tool to import contact records from an Excel file. The contact import process allows you to bulk upload customer contact information into your system.',
        uploadProgressDescription: 'Please wait while we upload and process your contact file.',
        executionProgressTitle: 'Importing Contacts...',
        executionProgressDescription: 'Please wait while we import your contacts.',
        executionStatusMessage: 'Importing contacts...',
        completionTitle: 'Contact Import Complete!',
        completionDescription: 'Your contacts have been successfully imported.'
      };
    },
    field_definitions() {
      return {
        requiredFields: [
          {
            key: 'phone_number',
            label: 'Phone Number',
            description: 'Phone number(s) for the contact - you can select multiple columns',
            multiple: true,
            required: true,
            hint: 'Select one or more columns containing phone numbers'
          },
          {
            key: 'first_name',
            label: 'First Name',
            description: 'Contact\'s first name',
            multiple: false,
            required: true,
            hint: 'Select the column containing first names'
          },
          {
            key: 'last_name',
            label: 'Last Name',
            description: 'Contact\'s last name',
            multiple: false,
            required: true,
            hint: 'Select the column containing last names'
          }
        ],
        optionalFields: [
          { key: 'email', label: 'Email', description: 'Contact\'s email address', multiple: false, required: false, hint: 'Select the column containing email addresses' },
          { key: 'birthdate', label: 'Birthdate', description: 'Contact\'s birthdate', multiple: false, required: false, hint: 'Select the column containing birthdates (supports MM/DD/YYYY, MM/DD/YY, or YYYY-MM-DD formats)' },
          { key: 'notes', label: 'Notes', description: 'Contact\'s Notes', multiple: false, required: false, hint: 'Select the column containing notes about the contact' }
        ]
      };
    },
    preview_config() {
      return {
        tableHeaders: [
          { text: 'Include', value: 'select', align: 'center', sortable: false, alwaysShow: true },
          { text: 'Row', value: 'row_number', width: '50px', align: 'center', alwaysShow: true },
          { text: 'Contact Status', value: 'import_status',  align: 'center', alwaysShow: true },
          { text: 'Phone Number', value: 'rc_phone_number',  align: 'left', alwaysShow: true },
          { text: 'First Name', value: 'rc_first_name' },
          { text: 'Last Name', value: 'rc_last_name' },
          { text: 'Email', value: 'rc_email' },
          { text: 'Birthdate', value: 'rc_birthdate' },
          { text: 'Notes', value: 'rc_notes' },
          { text: 'Phone Validation Status', value: 'rc_validation_status' },
          { text: 'System Notes', value: 'rc_system_notes' },
          { text: 'Errors', value: 'errors', alwaysShow: true }
        ],
        customColumns: [ { key: 'select', type: 'custom' } ]
      };
    }
  }
};
</script>

